import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=63c8ff8e&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=ts"
export * from "./BaseModal.vue?vue&type=script&lang=ts"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=63c8ff8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c8ff8e",
  null
  
)

export default component.exports